
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/yotpo-alternative",
      function () {
        return require("private-next-pages/yotpo-alternative.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/yotpo-alternative"])
      });
    }
  